import guide from 'config/guide';

import { apiURLNew, callAPI } from 'api/main';

interface IParams {
  token: string;
}

export default async ({ token }: IParams): Promise<any> => {
  try {
    const res = await callAPI({
      url: `${apiURLNew}/user/public/auth/v1/check-token`,
      method: 'POST',
      isLegacy: false,
      params: {
        token,
        guid: guide,
      },
    });

    const data = res.request;

    if (data) {
      return data;
    }

    null;
  } catch (ex) {
    return null;
  }
};
